import styled from 'styled-components';

export const PreviewFormSC = styled.div`
  width: 100%;
  background: #fff;

  .overview {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* identical to box height, or 143% */

    color: #464b5d;

    .highlight {
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;

      /* identical to box height, or 100% */

      text-align: center;
      color: #6ad5e5;
    }
  }

  .pill-wrapper {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .time-pill {
      width: fit-content;
      padding: 4px 10px;
      margin-right: 15px;
      margin-bottom: 15px;
      background: #efeff3;
      border-radius: 14px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;

      /* identical to box height, or 143% */

      text-align: center;
      color: #333d6c;

      &.extra {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;

        /* identical to box height, or 143% */

        text-align: center;
        color: #fff;
        background: #333d6c;
        border-radius: 14px;
        cursor: pointer;
      }
    }
  }

  .repeat-container {
    margin-top: 15px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* identical to box height, or 143% */

    color: #464b5d;

    svg {
      margin-right: 12px;
    }
  }

  .description-title,
  .description {
    opacity: 0.5;
  }

  .description-title {
    margin-top: 25px;
  }
`;
